// removed by extract-text-webpack-plugin
module.exports = {"mobile":"_1LWI5","desktop":"_2p866","dialogRoot":"_1-Wpg","children":"_3KUVz"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/SocialMedia/components/LikeBlock/components/LoginDialog/LoginDialog.scss
// module id = 1180
// module chunks = 2